import { useRef, useReducer, useCallback } from 'react';
import axios from "axios";

export const useApiHook = (endpoint, { verb = "get", useCache = false, token = '', params = {} } = {}) => {
	const cache = useRef({});

	const initialState = {
		status: 'idle',
		loading: false,
		error: null,
		data: [],
	};

	const [state, dispatch] = useReducer((state, action) => {
		switch (action.type) {
			case 'FETCHING':
				return { ...initialState, status: 'fetching', loading: true };
			case 'FETCHED': 
				return { ...initialState, status: 'fetched', data: action.payload, loading: false };
			case 'FETCH_ERROR':
				return { ...initialState, status: 'error', error: action.payload, loading: false };
			default:
				return state;
		}
	}, initialState);


	 const callAPI = useCallback(async () => {
		
		if (!endpoint) return;
	
			dispatch({ type: 'FETCHING' });
			
				try {
					axios.defaults.headers['Pragma'] = 'no - cache';
					if (token !== '' && token !== null) {
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
					}
					
					var endpoint_ = location.origin + '/' + endpoint;
					const response = await axios[verb](endpoint_, params);
					var status = '';
					if (typeof (response.data.status) != 'undefined')
					{ status = response.data.status;}
					else
					{
						status = response.status;
						if (status === 200) { status = 'OK'; }
					}
					
					if (status === 'OK') {

						dispatch({ type: 'FETCHED', payload: response.data });
						
					}
					else {

						const err = response.data.errMsg;
						console.log(err);
						dispatch({ type: 'FETCH_ERROR', payload: err });
						
					}

				} catch (error) {
					console.log(error);
					dispatch({ type: 'FETCH_ERROR', payload: error.message });
					
				}
			
	

	}, [endpoint, verb, useCache, params]);

	

	return [state, callAPI];
};